/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createJingleCollectionModelSchema } from "../createJingleCollectionModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiJingleCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Идентификатор обновляемой подборки
 */
export const putApiJingleCollectionsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Подборка уже существует
 */
export const putApiJingleCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiJingleCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiJingleCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const putApiJingleCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiJingleCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiJingleCollectionsIdMutationRequestSchema = z.lazy(() => createJingleCollectionModelSchema).describe("Тело запроса")

export const putApiJingleCollectionsIdMutationResponseSchema = z.lazy(() => putApiJingleCollectionsId200Schema)